module.exports = __webpack_public_path__ + "img/item3.5422bfe5.png";